var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIconButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "10 5 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 28.5C23.7928 28.5 23.5941 28.4177 23.4476 28.2712C23.3011 28.1247 23.2188 27.926 23.2188 27.7188V13.2812C23.2188 13.074 23.3011 12.8753 23.4476 12.7288C23.5941 12.5823 23.7928 12.5 24 12.5C24.2072 12.5 24.4059 12.5823 24.5524 12.7288C24.6989 12.8753 24.7812 13.074 24.7812 13.2812V27.7188C24.7812 27.926 24.6989 28.1247 24.5524 28.2712C24.4059 28.4177 24.2072 28.5 24 28.5Z",
    fill: "#E42125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2188 21.2812H16.7812C16.574 21.2812 16.3753 21.1989 16.2288 21.0524C16.0823 20.9059 16 20.7072 16 20.5C16 20.2928 16.0823 20.0941 16.2288 19.9476C16.3753 19.8011 16.574 19.7188 16.7812 19.7188H31.2188C31.426 19.7188 31.6247 19.8011 31.7712 19.9476C31.9177 20.0941 32 20.2928 32 20.5C32 20.7072 31.9177 20.9059 31.7712 21.0524C31.6247 21.1989 31.426 21.2812 31.2188 21.2812Z",
    fill: "#E42125"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconButton);
export default __webpack_public_path__ + "static/media/AddIconButton.1892b5b2782984705b4da74a7089adbf.svg";
export { ForwardRef as ReactComponent };